import React, { useState, useEffect } from 'react'
import OrdersTable from './OrdersTable'
import OrderDrawer from './OrdersDrawer'
import { Table, Col, Row, Card, message, Select, Button } from 'antd'
import inventorySrc from '../../inventorySrc'

const { Option } = Select

function OrdersTab(props) {
    const [showDrawer, setShowDrawer] = useState(false)
    const [viewOrder, setViewOrder] = useState({})
    const [loading, setLoading] = useState(false)
    const [fetchData, setFetchData] = useState(false)

    useEffect(() => {
        if (showDrawer === false) setViewOrder({})
    }, [showDrawer])

    const onViewOrder = id => {
        setLoading(true)
        inventorySrc
            .getOrder(id)
            .then(order => {
                setViewOrder(order)
                setShowDrawer(true)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                message.error('No se ha podido cargar la orden.')
                setLoading(false)
            })
    }

    return (
        <div>
            <Row gutter={16}>
                <Col xs={7} sm={7} md={7} lg={7}>
                    <Select
                        value={props.selectedOption}
                        className={'single-select'}
                        placeholder={'Selecciona una tienda'}
                        size={'large'}
                        style={{ width: '100%' }}
                        onChange={option => {
                            props.setSelectedOption(option)
                        }}
                    >
                        {props.shopsList.map(option => (
                            <Option key={option.id} value={option.id}>
                                {option.name}
                            </Option>
                        ))}
                    </Select>
                </Col>
            </Row>
            <Row gutter={16} className={'section-space-field'}>
                {props.selectedOption ? (
                    <Col span={24} className={'margin-top-15'}>
                        {
                            <OrdersTable
                                keyTab={props.keyTab}
                                onView={onViewOrder}
                                selectedOption={props.selectedOption}
                                fetchData={fetchData}
                            />
                        }
                    </Col>
                ) : (
                    <Col span={24} className={'empty-section-container'}>
                        <div className={'empty-section'}>
                            <span className={'empty-section-message'}>Por favor selecciona una tienda</span>
                        </div>
                    </Col>
                )}
            </Row>
            <OrderDrawer
                closable={setShowDrawer}
                loading={loading}
                visible={showDrawer}
                viewOrder={viewOrder}
                setFetchData={setFetchData}
            />
        </div>
    )
}

export default OrdersTab